import { useQuery } from "@tanstack/react-query";
import { qrBatchApi } from "./axios";
import {
  DataI,
  ServiceResponseI,
  QrCodeI,
  PropsQrCodeI,
} from "../../interfaces";
import { ValidateCurrentToken, LogoutSystem } from "../../helpers";
import { AxiosError } from "axios";

const getAllQrCodesByBatch = async ({
  pagination,
  qrBatchId,
}: PropsQrCodeI): Promise<ServiceResponseI<DataI<QrCodeI>>> => {
  try {
    const validateToken = ValidateCurrentToken();
    if (!validateToken) throw new Error("TOKEN INVALIDO");

    const params = new URLSearchParams();
    params.append("page", (pagination!.pageIndex + 1).toString());
    params.append("limit", pagination!.pageSize.toString());

    // El id del lote va en la ruta: /qr-batch/:id/codes
    const { data } = await qrBatchApi.get<ServiceResponseI<DataI<QrCodeI>>>(
      `/${qrBatchId}/codes`,
      { params, headers: { Authorization: validateToken } },
    );
    return data;
  } catch (err) {
    const obj = (err as AxiosError).response;
    if (obj?.status === 401) LogoutSystem();
    throw new Error((err as Error).message);
  }
};

export const useQrCodesByBatch = ({ pagination, qrBatchId }: PropsQrCodeI) => {
  const qrCodesQuery = useQuery(
    ["qr-codes", { pagination, qrBatchId }],
    () => getAllQrCodesByBatch({ pagination, qrBatchId }),
    {
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      enabled: Boolean(qrBatchId),
    },
  );

  return { qrCodesQuery };
};